import React from "react";
import { Autocomplete, TextField } from "..";
import styles from "./search-field.module.scss";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import { isAlphaNumeric, isAlphaNumericWithSymbols } from "utils/text.utils";
const SearchTypeField = ({
  name,
  onClear,
  onChange,
  restrict = true,
  searchWithSymbols = false,
  searchKeyName,
  searchKeyValue,
  searchKeyOptions,
  searchKeyOnChange,
  disableClearable,
  ...props
}) => {
  return (
    <div className={styles.combinedWrapper}>
      <div className={styles.textFieldWrapper}>
        <TextField
          onChange={(name, { value }) => {
            if (searchWithSymbols) {
              if (restrict && !isAlphaNumericWithSymbols(value)) return;
            } else {
              if (restrict && !isAlphaNumeric(value)) return;
            }

            onChange(name, { value });
          }}
          {...props}
          prefix={<SearchIcon className={styles.searchIcon} />}
          suffix={
            props.value ? (
              <CloseIcon
                className={styles.clearIcon}
                onClick={() => {
                  if (onClear) {
                    onClear();
                  } else {
                    onChange(name, { value: "" });
                    props.onEnter();
                  }
                }}
              />
            ) : null
          }
          className={styles.inputNoBorder}
        />
      </div>

      <div className={styles.divider}></div>

      <div className={styles.autocompleteWrapper}>
        <Autocomplete
          name={searchKeyName}
          value={searchKeyValue}
          options={searchKeyOptions}
          onChange={searchKeyOnChange}
          className={styles.inputNoBorder}
          disableClearable={true}
          placeholder={"Type"}
        />
      </div>
    </div>
  );
};

export default SearchTypeField;
